// extracted by mini-css-extract-plugin
export var scrollArea = "_r4-0";